import React, { useContext } from 'react';
import { createPortal } from 'react-dom';
import { Preview as DnDPreview, Context as PreviewContext } from 'react-dnd-preview';
import { useObservePreviews } from '../hooks/useObservePreviews';
import { PreviewPortalContext } from './DndProvider';
export var Preview = function Preview(props) {
  var enabled = useObservePreviews();
  var portal = useContext(PreviewPortalContext);

  if (!enabled) {
    return null;
  }

  var result = /*#__PURE__*/React.createElement(DnDPreview, props);

  if (portal !== null) {
    return /*#__PURE__*/createPortal(result, portal);
  }

  return result;
};
Preview.Context = PreviewContext;
export { PreviewContext };